//import React, { useContext } from 'react';
import { Page } from 'grommet';
import Iframe from 'react-iframe';

export const NetworkHome = () => {
  //const [user, setUser] = useState(defaultUser);
  //const size = useContext(ResponsiveContext);

  return (
    <Page flex="grow" background="background">

      <Iframe
        url="https://dashboard.capenetworks.com/circles"
        width="100%"
        height="100%"
        frameBorder="0"
        overflow="visible"
        allow="fullscreen"
        scrolling="no"
        id=""
        className=""
      />

    </Page>
  );
};